import { Injectable, InjectionToken, inject } from '@angular/core';
import { portalPath } from '@core/navigation/portal-path';

/** Where the Partner Portal is mounted. Override with `''` when it moves to its own subdomain. */
export const PARTNER_BASE_PATH = new InjectionToken<string>('PARTNER_BASE_PATH', {
  providedIn: 'root',
  factory: () => '/partner',
});

/** Builds Partner Portal URLs; never hard-code `/partner/...`. */
@Injectable({ providedIn: 'root' })
export class PartnerLinks {
  private readonly base = inject(PARTNER_BASE_PATH);

  to(...segments: (string | number)[]): string {
    return portalPath(this.base, ...segments);
  }
}
